import { FlussInstanceSummary } from "modules/fluss/types/fluss";

export const currentNodeLabel = (instance: FlussInstanceSummary) =>
    instance.current_node_labels?.filter(Boolean).join(" · ") || instance.current_node_label || "—";
